import { createButtonLink } from '@vfde-brix/ws10/button-link';
import { HtmlId } from '../enum';
import { mountComponent } from '../util/mount';

/**
 * Create Brix ButtonLink component.
 * @param {string} id - ID of the button element
 * @param {Function} [onClick] - click event handler
 */
export const mountButtonLink = (id: HtmlId, onClick?: Function) =>
    mountComponent(id, createButtonLink, {
        onClick: (e: Event) => {
            e.preventDefault();
            onClick?.();
        },
    });
